const KEYS = {
  qrCode: 'qrCodeImage2FA',
  userNo: 'userNo',
  secretKey: 'secretKey',
  // is2FAVerified: 'is2FAVerified',
  isLoggedIn: 'isLoggedIn'
};

console.log("✅ AuthSessionManager is running");

const AuthSessionManager = {
  save2FASession: ({ qrCode, userNo, secretKey }) => {
    localStorage.setItem(KEYS.qrCode, qrCode);
    localStorage.setItem(KEYS.userNo, userNo);
    localStorage.setItem(KEYS.secretKey, secretKey);
  },

  get2FASession: () => ({
    qrCode: localStorage.getItem(KEYS.qrCode),
    userNo: localStorage.getItem(KEYS.userNo),
    secretKey: localStorage.getItem(KEYS.secretKey),
  }),

  clear2FASession: () => {
    Object.values(KEYS).forEach((key) => {
      if (key !== KEYS.isLoggedIn) {
        localStorage.removeItem(key);
      }
    });
  },

  setLoggedIn: (status = true) => {
    localStorage.setItem(KEYS.isLoggedIn, status.toString());
  },

  isLoggedIn: () => localStorage.getItem(KEYS.isLoggedIn) === 'true',

  set2FAVerified: (status = true) => {
    localStorage.setItem(KEYS.is2FAVerified, status.toString());
  },

  is2FAVerified: () => localStorage.getItem(KEYS.is2FAVerified) === 'true'
};

export default AuthSessionManager;
